<template>
  <teleport to="body">
    <HoursDetailModal
      v-if="open && employee && week"
      :employee="employee"
      :week="computedWeek"
      :period-start="periodStart"
      :period-end="periodEnd"
      :extra-proposed-hours-by-week="extraProposedHoursByWeek"
      :extra-proposals="extraProposals"
      @close="$emit('close')"
    />
  </teleport>
</template>

<script setup>
import { computed } from 'vue'
import HoursDetailModal from './HoursDetailModal.vue'

const props = defineProps({
  open: { type: Boolean, default: false },
  employee: { type: Object, required: false },
  week: { type: Object, required: false },
  periodStart: { type: String, required: false, default: null },
  periodEnd: { type: String, required: false, default: null },
  extraProposedHoursByWeek: { type: Object, default: () => ({}) },
  extraProposals: { type: Array, default: () => [] }
})

defineEmits(['close'])

const computedWeek = computed(() => {
  if (!props.week) return null
  const w = props.week
  const iso = w.iso_label || w.iso_week || ''
  let end = w.week_end
  if (!end && w.week_start) {
    const d = new Date(w.week_start + 'T00:00:00')
    d.setDate(d.getDate() + 6)
    end = d.toISOString().slice(0, 10)
  }
  return { ...w, iso_label: iso, week_end: end }
})
</script>
